import axios from 'axios'
import store from '@/store'

export default {
  getTimeOffsSettings () {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/time-offs-settings/list`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('timeOffsSettings/setTimeOffsSetting', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getTimeOffsSettingsFull () {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/time-offs-settings`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('timeOffsSettings/setTimeOffsSetting', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  createTimeOffsSetting (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/time-offs-settings/`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  editTimeOffsSetting (params) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/time-offs-settings/${params.id}`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  removeTimeOffsSetting  (id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/time-offs-settings/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  }
}
